import { useBrand, brandUrl } from "@/hooks/useBrand";

const WORLD_MAP = "https://static.prod-images.emergentagent.com/jobs/d3313583-2c16-4c51-9634-1ffbceb1cd24/images/3a7dc5183c3739e2e0d78b2f383ff2935aabde5b8f0d454059ed66dcbf2e75ac.jpeg";

/** Ambiance vivante : papier peint baroque, carte du monde dorée, vagues passantes, logo filigrane qui respire. */
export default function BrandWatermark() {
  const brand = useBrand();
  const logo = brandUrl("mark", brand) || brandUrl("logo", brand);
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden select-none" aria-hidden="true" data-testid="brand-watermark">
      {/* Papier peint baroque, noir discret */}
      <div className="absolute inset-0 baroque-wallpaper" />

      {/* Carte du monde dorée (contours), filigrane */}
      <img
        src={WORLD_MAP}
        alt=""
        className="absolute"
        style={{ width: "min(160vh, 130vw)", left: "50%", top: "48%", transform: "translate(-50%, -50%)", opacity: 0.5, mixBlendMode: "screen" }}
        data-testid="brand-worldmap"
      />

      {/* Filigrane du logo qui respire */}
      {logo && (
        <img
          src={logo}
          alt=""
          className="absolute breathe-logo"
          style={{ width: "min(78vh, 78vw)", left: "50%", top: "47%", filter: "grayscale(35%)" }}
          data-testid="brand-watermark-logo"
        />
      )}

      {/* Vagues lumineuses passantes */}
      <div className="wave-sweep" data-testid="brand-wave" />
      <div className="wave-sweep wave-sweep--slow" />

      {/* Vignette pour la profondeur */}
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 40%, transparent 30%, rgba(5,5,5,0.55) 100%)" }} />
    </div>
  );
}
